export default function SlaBeacon({ level, className = "" }) {
  if (!level) return null;
  const color = level === "red" ? "bg-red-500" : "bg-amber-500";
  const title = level === "red"
    ? "RED SLA missed — 4+ working days without a quote sent to the client"
    : "AMBER SLA missed — 2+ working days without a quote added";
  return (
    <span className={`relative inline-flex h-2.5 w-2.5 shrink-0 ${className}`} title={title} data-testid={`sla-beacon-${level}`}>
      <span className={`animate-ping absolute inline-flex h-full w-full rounded-full ${color} opacity-75`} />
      <span className={`relative inline-flex rounded-full h-2.5 w-2.5 ${color}`} />
    </span>
  );
}

export function jrBeaconLevel(jr) {
  if (jr?.quote_sla_red_at && !jr?.quote_sla_red_resolved_at) return "red";
  if (jr?.quote_sla_amber_at && !jr?.quote_sla_amber_resolved_at) return "amber";
  return null;
}
